import { render, staticRenderFns } from "./recruitment-form.vue?vue&type=template&id=a5a1c696&scoped=true"
import script from "./recruitment-form.vue?vue&type=script&lang=js"
export * from "./recruitment-form.vue?vue&type=script&lang=js"
import style0 from "./recruitment-form.vue?vue&type=style&index=0&id=a5a1c696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a1c696",
  null
  
)

export default component.exports